import { Fragments } from "requests";

export const getDefaultValues = (
  procedures: Fragments.StoredMedicalCase["disclaimerProcedures"]
) => {
  const selected = procedures.find(procedure => procedure.selected);
  return {
    procedure: selected?._id
      ? selected._id.toString()
      : selected?.fakeId || null
  };
};
